import { render, staticRenderFns } from "./DePara.vue?vue&type=template&id=904725b0"
import script from "./DePara.vue?vue&type=script&lang=js"
export * from "./DePara.vue?vue&type=script&lang=js"
import style0 from "./DePara.vue?vue&type=style&index=0&id=904725b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports